import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login';
import { MastersService } from 'src/app/core/services/masters';
import { Profiles } from 'src/app/core/utils/profiles.enum';

@Component({
	selector: 'app-control-panel-comercial',
	templateUrl: './control-panel-comercial.component.html',
	styleUrls: ['./control-panel-comercial.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class ControlPanelComercialComponent implements OnInit {

	constructor(
		public activeModal: NgbActiveModal,
		private router: Router,
		private loginService: LoginService,
		private mastersService: MastersService
	) { }

	ngOnInit(): void { }

	closeModal(sendData?: any): void {
		this.activeModal.close(sendData);
	}

	goToCRM(): void {
		this.activeModal.close();
		this.router.navigate(['/comercial/crm']);
		this.mastersService.createActivityHistory(
			'crm',
			'Ha accedido al CRM desde el panel de control comercial.'
		);
	}
}
